import React from 'react';
import PropTypes from 'prop-types';
import IconButton from '@mui/material/IconButton';
import Box from '@mui/material/Box';
import { styled } from '@mui/system';
import { getHeaderAccentMain } from 'styles/helpers/getThemeStyles';
import { AppBarIcon } from 'components/AppBar';

const StyledIconButton = styled(IconButton)(({ theme }) => ({
  color: getHeaderAccentMain(theme),
  '&:hover': {
    opacity: '0.7',
    color: getHeaderAccentMain(theme)
  },
  '& .MuiSvgIcon-root': {
    fill: getHeaderAccentMain(theme)
  }
}));

function AppBarCartIconButton({ onClick, itemsInCart }) {
  return (
    <StyledIconButton
      onClick={onClick}
      color="secondary"
      data-testid="cart-icon"
      aria-label={`View Cart, ${itemsInCart} item${itemsInCart > 1 ? 's' : ''}`}
    >
      <Box mr={0.5} ml={1}>
        <AppBarIcon icon="cart" />
      </Box>
      {itemsInCart}
    </StyledIconButton>
  );
}

AppBarCartIconButton.propTypes = {
  onClick: PropTypes.func,
  itemsInCart: PropTypes.number
};

export default AppBarCartIconButton;
